import React from 'react';
import { UI_SCREEN_STYLES } from '../../styles/UISystem';
import IconBack from '../../components/UISystem/Icons/IconBack';
import { ColorSwatch, PRIMARY_COLORS } from '../../components/UISystem/Colors';

/**
 * Colors Screen - UI System subpage
 * 
 * Displays the color system documentation using reusable color components
 */
const ColorsScreen = ({ onBack }) => {
  return (
    <div style={UI_SCREEN_STYLES.container}>
      {/* Header with back button and title */}
      <div style={UI_SCREEN_STYLES.header}>
        {/* Back button */}
        <IconBack onClick={onBack} />
        
        {/* Title */}
        <h1 style={UI_SCREEN_STYLES.title}>
          Colors
        </h1>
      </div>
      
      {/* Horizontal line */}
      <div style={UI_SCREEN_STYLES.divider} />
      
      {/* Content */}
      <div style={UI_SCREEN_STYLES.content}>
        <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#6D7074', marginTop: 0 }}>Color Tokens</h2>
        {/* Color Swatches */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {PRIMARY_COLORS.map((colorData, index) => (
            <ColorSwatch
              key={index}
              name={colorData.name}
              color={colorData.color}
              description={colorData.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ColorsScreen;
